"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionForegroundService = void 0;
class InteractionForegroundService {
    constructor(handler) {
        this.handler = handler;
    }
    pushData(data) {
        this.handler.onInteractionDataReceived(data);
    }
    pushEvent(data) {
        this.handler.onEventDataReceived(data);
    }
}
exports.InteractionForegroundService = InteractionForegroundService;
//# sourceMappingURL=service.js.map